import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Loader from "../loader/loader";
import { toastFunction, errorToastFunction } from "../../utils/toast";
import FloatingLabelInput from "../FloatingLabelInput/FloatingLabelInput";
import axios from "axios";
import { backendURL } from "../../utils/backed-url";

const AddOneVoucherPayment = ({ onCancel, onSuccess = onCancel, clientId }) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      setErrorMessage("");

      const paymentData = {
        pin: data.pin.trim(),
        amount: parseFloat(data.amount),
        clientId: clientId.toString(),
      };

      const response = await axios.post(
        `${backendURL}/v1/api/flash/redeem/`,
        paymentData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Check for success in the response
      if (response.data && response.data.status === "success") {
        toastFunction(
          "One Voucher payment processed successfully",
          "success",
          "one-voucher-payment-success"
        );
        reset();
        onSuccess();
      } else if (response.data && response.data.status === "error") {
        // Handle error response
        const errMsg =
          response.data.message || "Failed to process One Voucher payment";
        setErrorMessage(errMsg);
        errorToastFunction(errMsg, "one-voucher-payment-error");
      } else {
        errorToastFunction(
          "Unexpected response from server",
          "one-voucher-payment-error"
        );
      }
    } catch (error) {
      console.error("One Voucher payment error:", error);
      // Access the error message from the response data
      let errMsg = "Failed to process One Voucher payment";

      if (error.response?.data) {
        if (error.response.data.message) {
          errMsg = error.response.data.message;
        } else if (error.response.data.error) {
          errMsg = error.response.data.error;
        }
      }

      setErrorMessage(errMsg);
      errorToastFunction(errMsg, "one-voucher-payment-error");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Loader sizeClass={"size--medium"} />;
  }

  return (
    <div className="basic-modal">
      <div className="basic-modal__header">
        <h3>Add One Voucher Payment</h3>
      </div>
      <div className="basic-modal__body">
        {errorMessage && (
          <div className="input-container__error">{errorMessage}</div>
        )}
        <form onSubmit={handleSubmit(onSubmit)} className="basic-modal__form">
          <FloatingLabelInput
            type={"text"}
            className={""}
            disabled={false}
            name={"pin"}
            register={register}
            rules={{
              required: "PIN is required",
              minLength: {
                value: 10,
                message: "PIN must be at least 10 characters",
              },
            }}
            placeholder={"Enter Voucher PIN"}
            errors={errors}
          />

          <FloatingLabelInput
            type={"number"}
            className={""}
            disabled={false}
            name={"amount"}
            register={register}
            rules={{
              required: "Amount is required",
              min: {
                value: 0.01,
                message: "Amount must be greater than 0",
              },
            }}
            placeholder={"Enter Amount"}
            errors={errors}
          />

          <div className="basic-modal__footer">
            <button
              type="button"
              onClick={onCancel}
              className="button button--secondary"
            >
              Cancel
            </button>
            <button type="submit" className="button button--primary">
              Process Voucher
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddOneVoucherPayment;
